<template>
  <page>
    <template slot="content">
      <q-and-a-content :title="'メンバー情報の変更と削除（退会）'">
        <template slot="content">
          <div class="text">
            <b>グループ管理</b>の<b>部門管理</b>画面にてメンバーを選択すると、当該メンバーの表示名等の情報を変更できます。<b>メンバーを削除する（退会）</b>こともできます。<br><br>
            <b>メンバーを移動</b>をタップし、複数のメンバーを選択すると、まとめて所属部門を変更することができます。
          </div>
          <img class="picture" src="../assets/images/features_admin/8.png">
        </template>
      </q-and-a-content>
    </template>
  </page>
</template>

<script>
  import Page from '@/components/Page'
  import QAndAContent from '@/components/QAndAContent.vue'

  export default {
    components: {
      Page,
      QAndAContent
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/FeaturesAdminUpdateMember.vue